module.exports = __webpack_public_path__ + "img/case2.d16ff840.png";